export default {
    fonts: {
        bg_regular: "'BasisGrotesquePro-Regular'",
        bg_black: "'BasisGrotesquePro-Black'",
        bg_medium: "'BasisGrotesquePro-Medium'",
        bg_light: "'BasisGrotesquePro-Light'",
        bg_bold: "'BasisGrotesquePro-Bold'",
    },
    colors: {
        gray: '#FAF9F9',
        text: {
            black: '#000',
            gray: '#797979'
        },
        background: {
            white: '#fff',
            gray: '#F9F9F9',
        },
    },
    sizes: {
        rightColumn: '52%'
    }
} 


// WEBPACK FOOTER //
// ./src/css/index.js